// extracted by mini-css-extract-plugin
module.exports = {"cookie-list":"CookieList_cookie-list__oQtiQ","cookieList":"CookieList_cookie-list__oQtiQ"};